import { render, staticRenderFns } from "./lectureNotes.vue?vue&type=template&id=27637502&"
import script from "./lectureNotes.vue?vue&type=script&lang=js&"
export * from "./lectureNotes.vue?vue&type=script&lang=js&"
import style0 from "./lectureNotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports